import * as React from 'react';

import type { RenderElementProps } from 'slate-react';

const TableRow: React.FC<RenderElementProps> = ({ attributes, children }) => {
  return <tr {...attributes}>{children}</tr>;
};

export default TableRow;
